module.exports = {
	siteName: 'search',
	site: {
		mancity: {},
	},
};
